<script>
import {
  Header as AppHeader,
  SidebarToggler,
  Footer as TheFooter,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
} from '@coreui/vue'
import userdropdown from './../views/dropdowns/userdropdown'
import nav from './../../_nav.js'
import { authComputed } from '@state/helpers'

export default {
  components: {
    userdropdown,
    SidebarToggler,
    AppHeader,
    TheFooter,
    AppSidebar,
    SidebarForm,
    SidebarFooter,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },
  data() {
    return {
      user: {},
      nav: nav.items,
      selected: null,
      isConnected: true,
      base64Image:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAABACAYAAAB3QpVBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFbElEQVR4nO2dW2sUQRSGn1V0FZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZVQFZ',
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.checkInternetConnectivity()
  },
  methods: {
    checkInternetConnectivity() {
      const isInternetAvailable = () => {
        fetch('https://google.com', { method: 'HEAD', mode: 'no-cors' })
          .then(() => {
            this.isConnected = true // Update connectivity status
          })
          .catch(() => {
            console.log('Internet is not available')
            this.isConnected = false // Update connectivity status
          })
      }

      // Check connectivity every 30 seconds (30000 milliseconds)
      setInterval(isInternetAvailable, 5000)
    },
  },
}
</script>

<template>
  <div class="app">
    <AppHeader
      style="background-color: #242424 !important; padding: 0 !important"
      fixed
    >
      <SidebarToggler display="lg" />

      <b-link class="navbar-brand" to="/">
        <img
          src="../../assets/images/c4logo.png"
          style="
            width: 70px;
            height: auto;
            left: 5% !important;
            position: absolute;
          "
        />
      </b-link>
      <b-navbar-nav class="ml-auto">
        <!-- <select
          v-model="selected"
          name="LeaveType"
          class="form-control"
          @change="changeOutlet()"
        >
          <option
            v-for="(option, index) in user.outletIds"
            :key="index"
          >
            {{ option }}
          </option>
        </select>-->
        <p class="username">
          {{ this.user.firstName }} {{ this.user.lastName }}
        </p>
        <userdropdown />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed style="background-color: #ecc22e !important">
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :nav-items="nav" style="font-color: #242424 !important" />
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <div v-if="!isConnected" class="overlay">
        <div class="overlay-content">
          <img :src="base64Image" class="wifi-icon" />
          <p>No internet connection!</p>
        </div>
      </div>
      <div class="main">
        <div class="container-fluid main-container">
          <slot />
        </div>
      </div>
      <div></div>
    </div>
    <TheFooter style="background-color: #242424">
      <!--footer-->
      <div>
        <a
          href="https://web.facebook.com/p/C4-Fitness-100063581798737/?_rdc=1&_rdr"
          >C4 FITNESS</a
        >
        <span class="ml-1" style="color: #ecc22e">&copy; 2026 C4 FITNESS</span>
      </div>
      <!-- <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="http://www.omak.co">OMAK</a>
      </div> -->
    </TheFooter>
  </div>
</template>

<style scoped>
/* stylelint-disable-next-line selector-class-pattern */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  text-align: center;
  color: white;
}

.wifi-icon {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
}

.main-container {
  padding-top: 24px;
}

.nav-link {
  font-size: small !important;
}

.username {
  padding-top: 10px;
  margin-bottom: 10px;
}
</style>

<style>
.sidebar .nav-link {
  color: #242424 !important;
}

.sidebar .nav-link:hover {
  color: #ffffff !important;
  background-color: #242424 !important;
}

.sidebar .nav-link .nav-icon {
  color: #242424 !important;
}

.sidebar .nav-link:hover .nav-icon {
  color: #ffffff !important;
}
</style>
